<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import CommonEndPoints from "@/services/westore/entities/common";
import { Order } from "@/services/westore/entities";
import OrderReturn from "@/services/westore/entities/orderReturn";

import Multiselect from "vue-multiselect";
import Faqs from "../../../components/faqs.vue";
import FormSkeleton from "../../../components/skeletons/form-skeleton.vue";
import { mapGetters } from "vuex";
export default {
  page: {
    title: "Return Order",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    Faqs,
    FormSkeleton,
  },
  data() {
    return {
      title: "New Return",
      subtitle: "Please fill all the mandatory fields.",
      submitted: false,
      loader: false,
      showContentLoader: true,
      isSuccess: false,
      successMessage: "",
      orderObject: {},
      customerId: null,
      faqs: [
        {
          question: "What's the easiest way to create a return?",
          answer: "What's the easiest way to create a return?",
        },
      ],
      expandForm: false,
      formInputs: {
        orderId: null,
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        cityId: 1,
        customerAddress: "",
        returnDate: null,
      },
      cities: [],
      orderSearchList: [],
      products: [],
      clonedProducts: [],
      isOrdersLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      userCountry: ["auth/userCountry"],
      services: ["auth/services"],
    }),
    checkLoader() {
      return this.loader;
    },
  },
  validations: {
    formInputs: {
      orderId: {
        required,
      },
      customerName: {
        required,
      },
      customerEmail: {
        required,
      },
      customerPhone: {
        required,
      },
      cityId: {
        required,
      },
      returnDate: {
        required,
      },
      customerAddress: {
        required,
      },
    },
  },
  created() {
    this.fillForm(this.$route.query, true);
    this.fetchOptions().then(() => this.init());
  },
  methods: {
    init() {
      this.formInputs.cityId = this.cities[0].id;
      this.showContentLoader = false;
    },
    searchInOrders(val) {
      this.isOrdersLoading = true;
      if (val) {
        Order.search({ order_number: val }).then((res) => {
          this.orderSearchList = res.data;
          this.isOrdersLoading = false;
        });
      } else {
        this.orderSearchList = [];
        this.isOrdersLoading = false;
      }
    },
    submitForm() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loader = true;
        const payloadProducts = [];
        this.products.forEach((el) => {
          payloadProducts.push({
            id: el.id,
            quantity: el.quantity,
          });
        });

        const payloadRequest = {
          customer_id: this.customerId,
          city_id: this.formInputs.cityId,
          order_id: this.formInputs.orderId,
          customer_collection_address: this.formInputs.customerAddress,
          expected_delivery_date: this.formInputs.returnDate,
          products: payloadProducts,
        };

        OrderReturn.store(payloadRequest)
          .then((res) => {
            this.successMessage = "Order Return has been created successfully";
            this.isSuccess = true;
            setTimeout(
              () =>
                this.$router.push({
                  name: "order-return-details",
                  params: { id: res.data.data.id },
                }),
              2000
            );
          })
          .catch(({ response }) => {
            this.loader = false;
            console.log("response", response.data);
            this.$toast.error(response.data.message);
          });
      }
    },
    reset() {
      this.formInputs = {
        orderId: null,
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        cityId: this.cities[0].id,
        customerAddress: "",
        returnDate: null,
      };
      this.products = [];
      this.clonedProducts = [];
      this.customerId = null;
      this.orderObject = {};
    },
    async fetchOptions() {
      const { data: cities } = await CommonEndPoints.getCities(
        this.userCountry.id
      );
      this.cities = cities;

      return Promise.resolve();
    },
    deleteProductRow(index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.products.splice(index, 1);
        }
      });
    },
    fillForm(order, isSaveToStorage = false) {
      if (Object.keys(order).length === 0) {
        return;
      }

      if (isSaveToStorage && order?.recipient?.name !== undefined) {
        localStorage.setItem(
          "returnedOrder",
          JSON.stringify(order, function replacer(key, value) {
            return value;
          })
        );
      }

      if (
        isSaveToStorage &&
        order?.recipient?.name === undefined &&
        localStorage.getItem("returnedOrder")
      ) {
        order = JSON.parse(localStorage.getItem("returnedOrder"));
      }
      this.formInputs = {
        ...this.formInputs,
        customerName: order?.recipient.name,
        orderId: order?.id,
        customerEmail: order?.recipient.email,
        customerPhone: order?.recipient.phone,
        customerAddress: order?.recipient.default_address.details,
      };
      this.products = JSON.parse(JSON.stringify(order?.products));
      this.clonedProducts = JSON.parse(JSON.stringify(this.products));
      this.customerId = order?.recipient.id;
      this.orderObject = order;
    },
    setRecipientData(order) {
      this.fillForm(order);
    },
    toggleFormListener(val) {
      this.expandForm = val;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :subtitle="subtitle" />
    <div class="row">
      <div
        class="col-md-9 col-sm-12 order-2 order-sm-12"
        :class="expandForm && 'col-md-11 col-sm-12'"
      >
        <div class="card">
          <FormSkeleton v-if="showContentLoader" />
          <div class="card-body" v-else>
            <div class="row">
              <div class="col-12">
                <form class="form-horizontal" @submit.prevent="submitForm">
                  <!-- Order ID -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Order Number *')"
                  >
                    <multiselect
                      placeholder="Please type order number"
                      @search-change="(val) => searchInOrders(val)"
                      @select="setRecipientData"
                      v-model="orderObject"
                      value-field="id"
                      text-field="order_number"
                      label="order_number"
                      :options="orderSearchList"
                      :loading="isOrdersLoading"
                      type="text"
                      :class="{
                        'is-invalid': submitted && $v.formInputs.orderId.$error,
                      }"
                    >
                    </multiselect>
                  </b-form-group>
                  <!-- Customer Name -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('CUSTOMER NAME *')"
                  >
                    <b-form-input
                      v-model="formInputs.customerName"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.customerName.$error,
                      }"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Customer Email -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Customer Email *')"
                  >
                    <b-form-input
                      v-model="formInputs.customerEmail"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.customerEmail.$error,
                      }"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Customer Phone -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Customer Phone *')"
                  >
                    <input
                      v-model="formInputs.customerPhone"
                      v-mask="'(##) ####-####'"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.customerPhone.$error,
                      }"
                    />
                    <span class="text-muted">e.g "(xx) xxxx-xxxx"</span>
                  </b-form-group>
                  <!-- Customer City/Area -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Customer City/Area *')"
                  >
                    <b-form-select
                      v-model="formInputs.cityId"
                      class="form-select"
                      value-field="id"
                      text-field="name"
                      :options="cities"
                      type="text"
                      :class="{
                        'is-invalid': submitted && $v.formInputs.cityId.$error,
                      }"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Recipient Collection address -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Customer Collection Address *')"
                  >
                    <b-form-input
                      v-model="formInputs.customerAddress"
                      type="text"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.customerAddress.$error,
                      }"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Customer Collection Date -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Expected Return Date *')"
                  >
                    <b-form-input
                      v-model="formInputs.returnDate"
                      type="date"
                      :class="{
                        'is-invalid':
                          submitted && $v.formInputs.returnDate.$error,
                      }"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Products -->
                  <b-form-group
                    class="mb-3"
                    label-size="lg"
                    :label="$t('Add the items for return *')"
                  >
                    <h4 class="card-title" v-if="products.length === 0">
                      <code class="pink--text">Select order first.</code>
                    </h4>
                    <div
                      v-for="(item, index) in products"
                      :key="index"
                      class="row"
                    >
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="sku">SKU *</label>
                        <input
                          id="sku"
                          v-model="item.sku"
                          type="text"
                          class="form-control"
                          readonly
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="product_name">Product Name * </label>
                        <input
                          id="product_name"
                          v-model="item.name"
                          type="text"
                          class="form-control"
                          readonly
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="unite_price">Unit Price (AED) * </label>
                        <input
                          id="unite_price"
                          v-model="item.price"
                          type="text"
                          class="form-control"
                          readonly
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="quantity">Quantity * </label>
                        <input
                          id="quantity"
                          v-model="item.quantity"
                          type="number"
                          min="1"
                          :max="clonedProducts[index].quantity"
                          class="form-control"
                        />
                      </div>
                      <div class="mb-3 col-xl-4 col-lg-4">
                        <label for="quantity">Total Price * </label>
                        <input
                          id="toatal"
                          :value="item.quantity * item.price"
                          type="number"
                          min="0"
                          class="form-control"
                          readonly
                        />
                      </div>
                      <div class="col-xl-2 col-lg-4 align-self-center">
                        <div class="d-grid">
                          <b-btn
                            class="btn btn-danger btn-block mt-4"
                            @click="deleteProductRow(index)"
                            ><i class="bx bx-trash"></i
                          ></b-btn>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                  <div class="d-flex justify-content-end">
                    <!-- Reset -->
                    <div>
                      <b-button
                        variant="warning"
                        :class="isRtl ? 'btn-block ml-2' : 'btn-block mr-2'"
                        @click="reset"
                      >
                        {{ $t("Reset") }}
                      </b-button>
                      <v-progress-circular
                        v-if="checkLoader"
                        :size="30"
                        color="secondary"
                        indeterminate
                      ></v-progress-circular>
                      <b-button
                        v-else
                        type="submit"
                        variant="primary"
                        class="btn-block"
                      >
                        {{ $t("Submit") }}
                      </b-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
        <!-- end card -->
      </div>
      <div
        class="order-1 order-sm-12"
        :class="
          expandForm
            ? 'col-md-1 col-sm-12  d-flex justify-content-end'
            : 'col-md-3 col-sm-12'
        "
      >
        <Faqs :faqs="faqs" title="Returns" @toggleForm="toggleFormListener">
          <v-expansion-panels>
            <v-expansion-panel class="panel">
              <v-expansion-panel-header class="panel__header">
                What's the easiest way to create a return?
                <template v-slot:actions>
                  <v-icon color="pink"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="panel__content opacity-75">
                <ol class="faqs-list">
                  <li>Open <span class="bg-secondary">Orders</span></li>
                  <li>Find and open the related fulfilment order</li>
                  <li>
                    the order view, click
                    <span class="bg-secondary">Initiate Return</span>
                  </li>
                  <li>Select the SKUs to return</li>
                  <li>Click <span class="bg-secondary">Create Return</span></li>
                  <li>
                    Enter the
                    <span class="bg-secondary">Expected Return Date</span>
                  </li>
                  <li>
                    Modify
                    <span class="bg-secondary">SKUs, Unit Prices</span> and<span
                      class="bg-secondary"
                      >Quantities</span
                    >
                    as required
                  </li>
                  <li>
                    Enter <span class="bg-secondary">Reasons of Return</span>
                  </li>
                  <li>Submit</li>
                </ol>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </Faqs>
      </div>
      <!-- end col -->
    </div>
    <v-snackbar
      color="success accent-2"
      elavation="24"
      top
      right
      v-model="isSuccess"
    >
      {{ successMessage }}
    </v-snackbar>
  </Layout>
</template>
<style lang="scss">
.multiselect__spinner:after {
  z-index: 10000;
}
.faqs-list {
  opacity: 0.75;
  li {
    padding: 2px;
  }
}
</style>
